import React from "react";
import axios from "axios";
// import { Base_Url } from './config'
import apiClient from "../utils/ApiClient";

export const AddEvent = async (data) => {
    try {
        const response = await apiClient.post(`/api/add-event`, data);
        return response.data;  // Return the response data
    } catch (error) {
        return error?.response?.data;  // Return error data if request fails
    }
};

export const getAllEvents = async (type,currentPage,itemsPerPage) => {
    try {
        const response = await apiClient.get(`/api/all-events?is_logistic=${type}&page=${currentPage}&listData=${itemsPerPage}`)
        return response.data;  // Return the response data
    } catch (error) {
        return error?.response?.data;  // Return error data if request fails
    }
};

export const deleteEvent = async (id) => {
    try {
        const response = await apiClient.get(`/api/destroy-event?event_id=${id}`)
        return response.data;  // Return the response data
    } catch (error) {
        return error?.response?.data;  // Return error data if request fails
    }
};


